module.exports = __webpack_public_path__ + "lp/img/camera_icn-off@2x.917e68d8.png";